import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import Modal from "shared/components/Modal";
import { COLOR_BLACK } from "shared/theme/colors";
import { useArticlePage } from "../../context";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmationModal: FC<Props> = (props) => {
  const { onSaveArticleDetails, isSubmittingArticle } = useArticlePage();

  const handleSaveChanges = async () => {
    await onSaveArticleDetails();
    props.onConfirm();
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      title="Are you sure you want to leave?"
      secondaryButtonTitle="Leave page"
      onSecondaryClick={props.onConfirm}
      primaryButtonTitle="Save changes"
      primaryColor="primary"
      onPrimaryClick={handleSaveChanges}
      isSubmitting={isSubmittingArticle}
      footerStyles={{
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
      }}
    >
      <Typography variant="bodyMRegular" color={COLOR_BLACK}>
        All unsaved changes will be lost. Save your changes before leaving the
        page.
      </Typography>
    </Modal>
  );
};

export default ConfirmationModal;
